export default "__VITE_ASSET__CYAJLGJp__"